"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeruComparisonParser = void 0;
var _services = require("../../../services");
class PeruComparisonParser {
  comparisonPlanName() {
    return _services.locale.localeString('Recommendation.OtherPlanName');
  }
}
exports.PeruComparisonParser = PeruComparisonParser;